<template>
  <div>
    <div v-if="!isValidUrl">{{ url }}</div>
    <a v-if="isValidUrl" :href="url" target="_blank">{{ url }}</a>
  </div>
</template>

<script>
import { validURL } from "@/utils/utils";

export default {
  props: ["url"],
  data() {
    return {
      isValidUrl: false,
    };
  },
  watch: {
    url: function (val) {
      this.isValidUrl = validURL(val);
    },
  },
  mounted() {
    this.isValidUrl = validURL(this.url);
  },
};
</script>
